import { uuidV4 } from "./uuidV4";

export const showToast = (opts = {}) => {
  const uniqueId = opts.id || uuidV4();
  const toastId = `toast-${uniqueId}`;

  const toastExists = document.getElementById(toastId);

  if (toastExists) {
    return;
  }

  const {
    title,
    subtitle = "",
    type = "info",
    timeout = 4000,
    links = {},
  } = opts;

  const toastHtml = `
        <div id="${toastId}" class="toast toast-${type}" style="display: none;">
          <div class="toast-icon-container"></div>
          <div class="toast-text-container">
            <span class="toast-text-container-title">${title}</span>
            <span class="toast-text-container-subtitle">${subtitle}</span>
          </div>
          <div class="toast-close">
            <i class="fa-regular fa-xmark"></i>
          </div>
        </div>`;

  const toastNotifications = document.getElementById("toast-notifications");

  toastNotifications.insertAdjacentHTML("beforeend", toastHtml);

  Object.entries(links).forEach(([kind, link]) => {
    const subtitleElement = document.querySelector(
      `#${toastId} .toast-text-container-subtitle`,
    );
    subtitleElement.insertAdjacentHTML(
      "beforeend",
      `<br /><a href="${link}" target="_blank">${kind}</a>`,
    );
  });

  const toast = document.getElementById(toastId);

  setTimeout(() => {
    toast.style.display = "flex";
    toast.style.opacity = "0";
    toast.style.transition = "opacity 400ms";
    toast.offsetHeight;
    toast.style.opacity = "1";
  }, 0);

  let toastTimeout;

  const removeToast = () => {
    toast.style.opacity = "0";

    setTimeout(() => {
      toast.remove();
      if (toastNotifications.children.length === 0) {
        toastNotifications.innerHTML = "";
      }
    }, 400);
  };

  const startTimeout = () => {
    toastTimeout = setTimeout(() => removeToast(), timeout);
  };

  startTimeout();

  const closeButton = toast.querySelector(".toast-close");
  closeButton.addEventListener("click", () => removeToast());

  toastNotifications.addEventListener("mouseenter", () => {
    clearTimeout(toastTimeout);
  });

  toastNotifications.addEventListener("mouseleave", () => {
    startTimeout();
  });
};
